const legends = [
  {
    label: 'Productive app - high time',
    color: '#14B8A6',
  },
  {
    label: 'Productive app - medium time',
    color: '#60A5FA',
  },
  {
    label: 'Productive app - low time',
    color: '#F59E0B',
  },
  {
    label: 'Non-productive app',
    color: '#EF4444',
  },
  {
    label: 'Zero / minimal use',
    color: '#D1D5DB',
  },
];

const UsageLegend = () => {
  return (
    <div
      className="
        flex
        flex-wrap
        items-center
        gap-x-4
        gap-y-2
      "
    >
      {legends.map((item) => (
        <div
          key={item.label}
          className="
            flex
            items-center
            gap-1.5
          "
        >
          <span
            className="
              h-[10px]
              w-[10px]
              rounded-[2px]
              shrink-0
            "
            style={{
              backgroundColor:
                item.color,
            }}
          />

          <span
            className="
              text-[11px]
              font-medium
              text-[#667085]
            "
          >
            {item.label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default UsageLegend;